/**
 * Leaf string interpolator for `{name}` placeholders.
 * Kept free of LanguageContext / timeFormat imports to avoid cycles.
 */
export function interpolate(
  template: string,
  values: Record<string, string | number>,
): string {
  let out = template;
  for (const [key, value] of Object.entries(values)) {
    out = out.split(`{${key}}`).join(String(value));
  }
  return out;
}
